import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    // TODO: connect to an email list (Mailchimp / Buttondown) to actually store the address.
    setSubmitted(true);
  };

  return (
    <section className="py-16 md:py-24 bg-cream">
      <div className="max-w-xl mx-auto px-6">
        <div className="bg-white py-12 px-8 md:px-12 text-center">
          <h2 className="font-inter text-sm md:text-base font-medium tracking-[0.3em] uppercase text-text-primary mb-6">
            SEASONAL TREATS
          </h2>

          <p className="font-inter text-xs leading-relaxed text-text-muted mb-8 max-w-sm mx-auto">
            Be first to hear about Mother’s Day, Valentine’s, and holiday cakes — a few emails a year, nothing more.
          </p>

          {submitted ? (
            <p className="font-inter text-xs tracking-[0.1em] uppercase text-text-primary py-3">
              Thank you — we’ll be in touch.
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="w-full border border-gray-300 px-4 py-3 font-inter text-xs tracking-[0.05em] text-text-primary placeholder:text-text-muted/50 focus:outline-none focus:border-text-primary transition-colors"
                aria-label="Your email address"
              />
              <button
                type="submit"
                className="font-inter text-xs tracking-[0.2em] uppercase text-text-primary bg-transparent border-0 cursor-pointer pb-1 border-b-2 border-sage hover:opacity-80 transition-opacity"
              >
                SUBSCRIBE
              </button>
            </form>
          )}

          <p className="font-inter text-[10px] leading-relaxed text-text-muted/60 mt-6 max-w-xs mx-auto">
            No spam. Unsubscribe anytime.
          </p>
        </div>
      </div>
    </section>
  );
}
